import { render, staticRenderFns } from "./ButtonWithLoader.vue?vue&type=template&id=5f35a136"
import script from "./ButtonWithLoader.vue?vue&type=script&lang=js"
export * from "./ButtonWithLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.99.5__lodash@4._b970ff0bca2018cb018adb640d1bec13/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports